import React from 'react';
import { flaps } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const StencilManualPrinting = (props) => {
  const name = 'manual_printing';
  const {
    tooltip, parameters, className, onChangeParameter, errorMessage, groupName
  } = props;
  const onChange = (e) => onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Are you using a SMT Stencil Printer?"
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      groupName={groupName}
      labelA="No"
      valueA="0"
      labelB="Yes"
      valueB="1"
      labelClassName="d-block"
      errorMessage={errorMessage} />
  );
};

StencilManualPrinting.defaultProps = {
  tooltip: flaps,
  className: 'class-3-inspection',
};

export default StencilManualPrinting;
